import { createFileRoute } from '@tanstack/react-router';
import { Wordmark } from '@client/components/brand/logo';

export const Route = createFileRoute('/admin-denied')({
  component: () => (
    <div className="flex min-h-dvh items-center justify-center bg-surface px-5">
      <div className="w-full max-w-[440px] rounded-panel border border-border bg-card p-8 shadow-panel">
        <Wordmark width={140} className="mb-6" />
        <h1 className="page-title">Staff access only</h1>
        <p className="mt-2 text-body">Sign in through Cloudflare Access with a ResilientX account that has been added as staff. If you believe you should have access, contact the administrator.</p>
      </div>
    </div>
  ),
});
